import { useQuery } from "@tanstack/react-query";

import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";

export const useIncomeTaxRates = ({
  countryIsoCode,
  regionIsoCode,
  year,
} = {}) => {
  const queryFn = useApiRequest({
    url: "/income-tax-rates",
    method: HttpMethod.Get,
    params: { countryIsoCode, regionIsoCode, year },
  });

  return useQuery({
    queryKey: ["income-tax-rates", countryIsoCode, regionIsoCode, year],
    queryFn,
  });
};
